import { render, staticRenderFns } from "./SearchBtn2.vue?vue&type=template&id=2043f810&scoped=true"
import script from "./SearchBtn2.vue?vue&type=script&lang=js"
export * from "./SearchBtn2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2043f810",
  null
  
)

export default component.exports